import Hero from "@/components/home/Hero";
import TrustStats from "@/components/home/TrustStats";
import Businesses from "@/components/home/Businesses";
import Categories from "@/components/home/Categories";
import OneStop from "@/components/home/OneStop";
import Importer from "@/components/home/Importer";
import OrderingShowcase from "@/components/home/OrderingShowcase";
import ReportingSection from "@/components/home/ReportingSection";
import DeliveryMap from "@/components/home/DeliveryMap";
import Onboarding from "@/components/home/Onboarding";
import PriceMatch from "@/components/home/PriceMatch";
import WarehouseGallery from "@/components/home/WarehouseGallery";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import Testimonials from "@/components/home/Testimonials";
import FaqSection from "@/components/home/FaqSection";
import FinalCta from "@/components/home/FinalCta";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStats />
      <Businesses />
      <Categories />
      <OneStop />
      <Importer />
      <OrderingShowcase />
      <ReportingSection />
      <DeliveryMap />
      <Onboarding />
      <PriceMatch />
      <WarehouseGallery />
      <WhyChooseUs />
      <Testimonials />
      <FaqSection limit={8} />
      <FinalCta />
    </>
  );
}
